/**
 * Entry point for the webclient.
 */
import "react-app-polyfill/ie9";
import { getUrlVars } from "./utils/Url";
import { THEME } from "./data/constants";

import * as React from "react";
import * as ReactDOM from "react-dom";
import HomePage from "./pages/HomePage";
import CustomPlaylistHomePage from "./pages/CustomPlaylistHomePage";
import PodCastService from "./services/podcast/PodcastService";

const podCastService = new PodCastService();

async function main() {
  const elements = document.querySelectorAll(".audioWidget");
  for (let i = 0; i < elements.length; i++) {
    const podCast = await podCastService.getPodCast(elements[i]);
    if (podCast.isCustomPlaylist === false && podCast.episodes) {
      ReactDOM.render(
        <HomePage
          podcast={podCast.episodes}
          customColors={getCustomColors(elements[i])}
          maxVisibleItems={getMaxVisibleItems(elements[i])}
          showSponsor={getshowSponsor(elements[i])}
          isCustomPlaylist={false}
          hidePodcastTitle={getHidePodcastTitle(elements[i])}
          hideEpisodeTitle={getHideEpisodeTitle(elements[i])}
        />,
        elements[i]
      );
    } else if (
      podCast.isCustomPlaylist === true &&
      getEpisodes(podCast).length
    ) {
      const episodes = getEpisodes(podCast);
      ReactDOM.render(
        <CustomPlaylistHomePage
          podcast={podCast.episodes}
          episodes={episodes}
          isCustomPlaylist={true}
          customColors={getCustomColors(elements[i])}
          maxVisibleItems={getMaxVisibleItems(elements[i])}
          showSponsor={getshowSponsor(elements[i])}
          hidePodcastTitle={getHidePodcastTitle(elements[i])}
          hideEpisodeTitle={getHideEpisodeTitle(elements[i])}
        />,
        elements[i]
      );
    } else if (!podCast && podCast.episodes.length <= 0) {
      ReactDOM.render(
        <div>No audio found. Please check if article has audio.</div>,
        elements[i]
      );
    }
  }
}

function getEpisodes(podCast) {
  let episodeArray = [];
  podCast.episodes.map((podcast, index) => {
    episodeArray.push(podcast.episodes[0]);
  });
  return episodeArray;
}

/**
 * Sets custom parameters.
 * Priority:
 * 1) URL Params.
 * 2) Root element attributes.
 * 3) Standard setting.
 */
function getCustomColors(element) {
  const colors = element.getAttribute("data-colors");

  if (getUrlVars().colors) {
    return getUrlVars().colors.split(",");
  } else if (getUrlVars().theme === "fd") {
    return THEME.FD;
  } else if (colors) {
    return colors.split(",");
  } else if (element.getAttribute("data-theme") === "fd") {
    return THEME.FD;
  }

  return [];
}

function getMaxVisibleItems(element) {
  const maxVisibleItems = element.getAttribute("data-maxVisibleItems");

  if (getUrlVars().maxVisibleItems) {
    return getUrlVars().maxVisibleItems;
  } else if (maxVisibleItems) {
    return maxVisibleItems;
  }

  return 5;
}

function getshowSponsor(element) {
  const showSponsor = element.getAttribute("data-showSponsor");
  if (getUrlVars().showSponsor) {
    return getUrlVars().showSponsor;
  } else if (showSponsor) {
    return showSponsor;
  }

  return "false";
}

function getHidePodcastTitle(element) {
  const hidePodcastTitle = element.getAttribute("data-hidePodcastTitle");
  if (getUrlVars().hidePodcastTitle) {
    return getUrlVars().hidePodcastTitle;
  } else if (hidePodcastTitle) {
    return hidePodcastTitle;
  }

  return "false";
}

function getHideEpisodeTitle(element) {
  const hideEpisodeTitle = element.getAttribute("data-hideEpisodeTitle");
  if (getUrlVars().hideEpisodeTitle) {
    return getUrlVars().hideEpisodeTitle;
  } else if (hideEpisodeTitle) {
    return hideEpisodeTitle;
  }

  return "false";
}

main().catch(e => console.error(e));
